import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

// A pair of text links per row, each independently hideable based on the row's own
// data (e.g. hide "Add" once a row is already Added, hide "Ignore" once it's already
// Ignored) — unlike dual-button-functions (which always shows both actions as
// <ds-button> pills), this supports per-row conditional visibility for each link.
@Component({
    selector: 'perk-action-links-renderer',
    templateUrl: './perk-action-links-renderer.component.html',
    standalone: true,
    imports: [CommonModule]
})
export class PerkActionLinksRendererComponent implements ICellRendererAngularComp {
    params: ICellRendererParams;
    label1 = '';
    label2 = '';
    hide1 = false;
    hide2 = false;

    initilize(params: ICellRendererParams) {
        this.params = params;
        const cfg = params.colDef.headerComponentParams;
        if (cfg && params.data) {
            this.label1 = cfg.label1;
            this.label2 = cfg.label2;
            this.hide1 = typeof cfg.isHidden1 === 'function' ? cfg.isHidden1(params.data) : false;
            this.hide2 = typeof cfg.isHidden2 === 'function' ? cfg.isHidden2(params.data) : false;
        }
    }

    agInit(params: ICellRendererParams): void {
        this.initilize(params);
    }

    refresh(params: ICellRendererParams): boolean {
        this.initilize(params);
        return true;
    }

    onAction1() {
        this.params.data.userAction = 'action1';
        this.params.node.setData(this.params.data);
        (this.params as any).eGridCell.click();
    }

    onAction2() {
        this.params.data.userAction = 'action2';
        this.params.node.setData(this.params.data);
        (this.params as any).eGridCell.click();
    }
}
